import { HTMLAttributes, useEffect } from 'react';
import { ControllerRenderProps } from 'react-hook-form';

import { RadioGroupModel } from '../../../radio-group/radio-group-model';
import { Attribute } from '../attribute';
import { FieldWrapper } from '../field-wrapper';

interface RadioRenderProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  attribute: Attribute;
  field: ControllerRenderProps<any>;
  isLoading?: boolean;
}

export function RadioRender({ attribute, className, field, isLoading }: RadioRenderProps) {
  const { id, model, radio, readOnly, disabled } = attribute;

  const radioModelValues = new Set(
    (model ?? [])
      .map((item) => item?.value)
      .filter((item): item is string => typeof item === 'string' && item.trim() !== ''),
  );

  const radioCurrentValue = typeof field.value === 'string' ? field.value : '';
  const radioSanitizedValue = radioModelValues.has(radioCurrentValue) ? radioCurrentValue : '';

  const hasInitializedWithInvalidValue =
    field.value != null && field.value !== '' && radioSanitizedValue !== radioCurrentValue;

  useEffect(() => {
    if (!hasInitializedWithInvalidValue) return;
    field.onChange('');
  }, [field, hasInitializedWithInvalidValue]);

  return (
    <FieldWrapper className={className} {...attribute}>
      <RadioGroupModel
        className={radio?.className ?? ''}
        disabled={disabled}
        disabledOnlyStyles={readOnly}
        id={id}
        isLoading={isLoading}
        model={model ?? []}
        type={radio?.type}
        value={radioSanitizedValue}
        onValueChange={(value) => field.onChange(radioModelValues.has(value) ? value : '')}
      />
    </FieldWrapper>
  );
}
